<div>
    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header" style="font-weight: 700;">Dynamic Form Templates</h4>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col">
            <div widget class="card border-0 box-shadow" style="min-height: 700px;padding: inherit;">
                <div>
                    <div class="row mt-2">
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Select Type </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [searchable]="true" [(ngModel)]="FilterselectedType" [clearable]="true"
                                    [items]="dynamicFormTemplateType" bindLabel="typeName" bindValue="id"
                                    (ngModelChange)="getDynamicFormTemplateFilter();">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Select Status </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [searchable]="true" [(ngModel)]="statusFilter" [clearable]="true"
                                [items]="statusList" bindLabel="lovName" bindValue="id"
                                (ngModelChange)="getDynamicFormTemplateFilter();">
                            </ng-select>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3"> -->
                            <!-- <div class="col-lg-12"> -->
                                <!-- <label style="font-weight:bold">Select Group</label> -->
                            <!-- </div> -->
                            <!-- <div class="col-lg-12"> -->
                                <!-- <ng-select  [(ngModel)]="FilterGroupType" [items]="GroupNameList" bindLabel="label" bindValue="value"
                              (ngModelChange)="getDynamicFormTemplateFilter()"  [disabled]="FilterselectedType==null||FilterselectedType==undefined||FilterselectedType==''" >
                              </ng-select> -->
                            <!-- </div> -->
                        <!-- </div> -->
                        <div class="col-lg-6 flex-end">
                            <div class="col-lg-12">
                                <label style="font-weight:bold"> </label>
                            </div>
                            <div class="col-lg-12">
                                <button class="btn blue-btn btn-sm  me-2 " style="float:right"
                                    data-bs-target="#staticBackdrop" data-bs-toggle="modal" (click)="AddnewTemplate();">Add Dynamic
                                    Template</button>
                            </div>
                        </div>
                    </div>
                    <!-- ejs -grid -->
                    <div class="row mt-2 pl-3 pr-3">
                        <div class="col-lg-12">
                            <ejs-grid #gridDynamicFormTemplate [dataSource]='GridDataList | async'
                                [allowResizing]='true' (actionBegin)="onActionComplete($event)"
                                [pageSettings]='initialPage' (dataStateChange)='dataStateChange($event)'
                                [allowPaging]='true' [allowSorting]='true' [filterSettings]='filterOptions'
                                [allowFiltering]="true" (resizeStop)="onResize($event)" [showColumnChooser]='true'>
                                <e-columns>
                                    <e-column headerText="Actions" uid='action' textAlign='center'
                                        [allowEditing]='false' [allowFiltering]="false" [showInColumnChooser]='false'>
                                        <ng-template #template let-data>

                                            <button (click)="editTemplate(data);" class="btn btn-edit-table btngrid "
                                                data-bs-target="#staticBackdrop" data-bs-toggle="modal"><i
                                                    class="fa fa-edit"></i></button>
                                            <button class="btn btn-delete-table btngrid me-2"
                                                (click)="deleteTemplate(data.id)"><i class="fa fa-trash"></i></button>
                                            <button class="btn btn-edit-table btngrid"
                                                (click)="getDynamicFormTemplateDownloadUrl(data.id)"><i
                                                    class="fa fa-download"></i></button>
                                        </ng-template>
                                    </e-column>
                                    <e-column minWidth=100 field="name" headerText="Name" type="string"
                                        textAlign='left'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column minWidth=100 field="entityTypeCode" headerText="Entity TypeCode"
                                        textAlign='left' type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column minWidth=100 field="statusLname" headerText="Status" textAlign='left'
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column width="50" [showInColumnChooser]='false'>
                                        <ng-template #headerTemplate let-data>
                                            <div class="d-none d-lg-block">
                                                <span id='show' (click)='showDFT()'><i class="fa fa-cog fa-lg"
                                                        aria-hidden="true">
                                                    </i></span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Create Template -->
<span id="OpneSaveModal" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></span>
<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveBo.id=='00000000-0000-0000-0000-000000000000'"> Add
                        Dynamic Template </span>
                    <span *ngIf="saveBo.id!='00000000-0000-0000-0000-000000000000'"> Update
                        Dynamic Template </span>
                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                 
                <!-- Select status -->

                <div class="row">
                    <div class="col-lg-5">
                        <label style="font-weight: 600;margin-top:6px;">Status<span class="super-script">*</span>
                            </label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select [searchable]="true" [(ngModel)]="saveBo.statusLid" [clearable]="true"
                               
                                [items]="statusList1" bindLabel="lovName" bindValue="id">
                            </ng-select>
                      </div>
                      
                </div>

                <!-- Select Type -->
                <div class="row">
                    <div class="col-lg-5">
                        <label style="font-weight: 600;margin-top:6px;">Select Type<span class="super-script">*</span>
                        </label>
                    </div>
                    <div class="col-lg-6">
                        <div class="">
                            <ng-select [searchable]="true" [(ngModel)]="saveBo.entityTypeCode" [clearable]="true"
                                [disabled]="saveBo.id!='00000000-0000-0000-0000-000000000000'"
                                [items]="dynamicFormTemplateType" bindLabel="typeName" bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <!-- File -->
                <div class="row">
                    <div class="col-lg-5">
                        <label style="font-weight: 600;margin-top:6px;">File<span class="super-script">*</span>
                        </label>
                    </div>
                    <div class="col-lg-6" style="display: flex;">
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" accept="application/pdf" id="customFile"
                                name="filename" (change)="onFileUpload($event);"
                                [disabled]="saveBo.id!='00000000-0000-0000-0000-000000000000'" #fileInput>

                            <label for="customFile" style="color:#004290">{{saveBo.documentName}}</label>
                        </div>
                        <div class="text-end" *ngIf="saveBo.id!='00000000-0000-0000-0000-000000000000'">
                            <button (click)="generateDynamicForm(this.saveBo.id);" class="btn btn-edit-table mt-2 "
                                data-bs-toggle="modal" data-bs-target="#viewmodaltemplate"><i
                                    class="fa fa-edit"></i></button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-5">
                    </div>
                    <div class="col-lg-6 ml-2">
                        <span class="help-block text-danger text-center">
                            <p style="color: black">(Upload tagged PDF only)</p>
                        </span>
                    </div>
                </div>
                <!-- Template Name -->
                <div class="row">
                    <div class="col-lg-5">
                        <label style="font-weight: 600;margin-top:6px;">Template Name<span class="super-script">*</span>
                        </label>
                    </div>
                    <div class="col-lg-6">
                        <div class="">
                            <input type="text" [(ngModel)]="saveBo.name" class="form-control">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="isSaveorUpdateBoolean||
                saveBo.name==null||saveBo.name==undefined ||saveBo.name==''|| saveBo.documentName==null ||saveBo.documentName==undefined ||
                saveBo.documentName=='' ||saveBo.entityTypeCode==null||saveBo.entityTypeCode==undefined 
                ||saveBo.entityTypeCode==''||validatingFile " (click)="uploadDynamicFormTemplate();"><span
                        *ngIf="saveBo.id=='00000000-0000-0000-0000-000000000000'"> Save
                        &
                        Close</span>
                    <span *ngIf="saveBo.id!='00000000-0000-0000-0000-000000000000'"> Update
                        &
                        Close</span>

                </button>
                <button type="button" class="btn blue-btn btn-sm"
                    (click)="closeModeltemplate();clearModal();">Cancel</button>
            </div>
        </div>
    </div>
</div>




<!-- View Template -->
<span id="openTemplatemodal" data-bs-target="#viewmodaltemplate" data-bs-toggle="modal"></span>
<!-- Modal -->
<div class="modal fade" id="viewmodaltemplate" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="viewmodaltemplateLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span> View Dynamic
                        Template </span>
                </h5>
                <div class="col" style="text-align: right;">
                    <button type="button" class="btn blue-btn btn-sm btngrid" (click)="bindValues()">Update</button>
                    <button type="button" class="btn blue-btn btn-sm btngrid" (click)="closeViewPdf()">Close</button>
                </div>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4">
                        <label class="font-header">EntityTypeCode:</label>
                        <label> {{entityTypeCode}}
                        </label>
                    </div>
                    <div class="col-lg-8" style="text-align:right">
                        <label class="font-header">Name:</label>
                        <label> {{name}}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-9">

                    </div>
                    <div class="col-lg-3">
                        <label style="color: black !important;"><i>Mapping Section
                            </i></label>
                    </div>
                </div>
                <div class='row'>
                    <div class="col-lg-9">
                        <ngx-extended-pdf-viewer [src]="FileURl" [textLayer]="false"
                            (click)="getSpecificFormField($event)" [showToolbar]="true" [showSidebarButton]="true"
                            [showFindButton]="false" [showPagingButtons]="true" [showDrawEditor]="false"
                            [showTextEditor]="false" [showZoomButtons]="true" [showPresentationModeButton]="false"
                            [showOpenFileButton]="false" [showPrintButton]="false" [showDownloadButton]="false"
                            [showSecondaryToolbarButton]="false" [showRotateButton]="false" [showHandToolButton]="false"
                            [showScrollingButton]="true" [showPropertiesButton]="false">
                        </ngx-extended-pdf-viewer>
                    </div>
                    <div class="col-lg-3  ml-0 mr-0 transparent text-muted"
                        *ngFor="let FormField of selectedFormFields;let form=index">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <label class="font-header" *ngIf="form==0">FormFieldName
                            </label>
                            <textarea type="text" class="form-control " disabled [(ngModel)]="FormField.formFieldName">
                            </textarea>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <label class="font-header" *ngIf="form==0">DynamicDataDictionary</label>
                            <ng-select [searchable]="true" [(ngModel)]="FormField.dynamicFormDataDictionaryId"
                                (ngModelChange)="FormField.defaultValue=null" [clearable]="true"
                                [items]="DynamicFormTemplateDataDictionary" bindLabel="dataName" bindValue="id">
                            </ng-select>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <label class="font-header" *ngIf="form==0">DefaultValue
                            </label>
                            <input type="text" class="form-control " [(ngModel)]="FormField.defaultValue"
                                [disabled]="FormField.dynamicFormDataDictionaryId!=null && FormField.dynamicFormDataDictionaryId!+undefined && FormField.dynamicFormDataDictionaryId!=''" />
                        </div>

                    </div>
                    <div class="col-lg-3" *ngIf="selectedFormFields.length==0">

                        <label class="mt-5" style="color: RED !important;"><i>Note:&nbsp; Select any field in Pdf
                            </i></label>

                    </div>


                </div>
            </div>
        </div>
    </div>
</div>




<span id="TemplateDropdeleteModal" data-bs-target="#dynamicmodaldata2" data-bs-toggle="modal"></span>
<div class="modal fade" id="dynamicmodaldata2" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteFunction()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>